<template>
  <div id="contenedor-main-expediente-contrato-ejecucion">
      <expediente
      :idReferencia="idReferencia"
      moduloExpedienteOrigen="contratos"
      soloLectura>
      </expediente>
  </div>
</template>

<script>
import Expediente from '@/views/administracion/expedientes/Main.vue';

export default {
  name: 'ExpedienteContratoEjecucionMain',
  components: {
    Expediente,
  },
  data() {
    return {
      idReferencia: this.$route.params.idContrato,
    };
  },

};
</script>

<style>

</style>
